/**
 * Cookie Consent Context Provider Component
 */

import { localStorageKeySeparator, localStoragePrefix } from '../../redux/helpers/localStorage';

import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { CookieContext } from './';
import { ICookieContext } from './types';

// tslint:disable-next-line:no-empty-interface
interface IOwnStateProps {
}

type CookieContextProviderProps = IOwnStateProps & Required<DispatchProp<any>>;

export const cookieConsentLocalStorageKey =
  `${localStoragePrefix}${localStorageKeySeparator}cookie-consent-received`;

export const cookieConsentClientCookieKey = 'bopper-cookie-consented';

export function getCookieConsentState() {
  try {
    if (localStorage.getItem(cookieConsentLocalStorageKey) === 'true') {
      return true;
    }
  } catch (e) {
    console.error(e);
  }

  if (document.cookie && document.cookie.indexOf(cookieConsentClientCookieKey) !== -1) {
    return true;
  }
  return false;
}

export function setCookieConsent() {
  try {
    localStorage.setItem(cookieConsentLocalStorageKey, 'true');
    if (localStorage.getItem(cookieConsentLocalStorageKey) !== 'true') {
      throw new Error('Could not set cookie consent to local storage.');
    }
  } catch (e) {
    console.error(e);
    document.cookie = `${cookieConsentClientCookieKey}=true`;
  }
}

class CookieContextProviderBase
  extends React.Component<CookieContextProviderProps, ICookieContext> {
  constructor(props) {
    super(props);

    this.state = {
      dispatch: this.props.dispatch,
      clear: this.clear,
      handleConsent: this.handleConsent,
      consentReceived: getCookieConsentState(),
    };
  }

  clear = () => {
    return;
  }

  handleConsent = () => {
    this.setState({ consentReceived: true }, () => {
      setCookieConsent();
    });
  }

  render() {
    return (
      <CookieContext.Provider value={this.state}>
        {this.props.children}
      </CookieContext.Provider>
    );
  }
}

export const CookieContextProvider = connect<IOwnStateProps, DispatchProp<any>, {}, IStoreState>(
  () => ({}),
  (dispatch) => ({ dispatch }),
)(CookieContextProviderBase);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/cookie/provider.tsx